<template>
    <div v-if="tours">
        <v-tour
                v-if="!tourIntro"
                name="introTour"
                :steps="introTour"
                :callbacks="callbacks"
                :options="tourOptions"
        ></v-tour>
        <v-tour
                v-if="!tourDashboard"
                name="dashboardTour"
                :steps="dashboardTour"
                :callbacks="callbacks"
                :options="tourOptions"
        ></v-tour>
        <v-tour
                v-if="!tourShop"
                name="shopTour"
                :steps="shopTour"
                :callbacks="callbacks"
                :options="tourOptions"
        ></v-tour>
    </div>
</template>

<script>
    import {
        mapActions,
        mapState,
    } from 'vuex';

    export default {
        name: 'tours',
        data() {
            return {
                currentTour: null,
                callbacks: {
                    onStart: this.onStart,
                    onPreviousStep: this.onPreviousStep,
                    onNextStep: this.onNextStep,
                    onSkip: this.onSkip,
                    onFinish: this.onFinish,
                },
                availableTours: [
                    {
                        id: 'introTour',
                        store: 'tourIntro',
                        route: '/static/intro',
                    },
                    {
                        id: 'dashboardTour',
                        store: 'tourDashboard',
                        route: '/dashboard',
                    },
                    {
                        id: 'shopTour',
                        store: 'tourShop',
                        route: '/shop',
                    },
                ],
            };
        },
        computed: {
            ...mapState([
                'tours',
                'tourIntro',
                'tourDashboard',
                'tourShop',
            ]),
            tourOptions() {
                return {
                    highlight: false,
                    labels: {
                        buttonSkip: this.$vuetify.lang.t('$vuetify.guidedtour.labels.skip'),
                        buttonPrevious: this.$vuetify.lang.t('$vuetify.guidedtour.labels.previous'),
                        buttonNext: this.$vuetify.lang.t('$vuetify.guidedtour.labels.next'),
                        buttonStop: this.$vuetify.lang.t('$vuetify.guidedtour.labels.stop'),
                    }
                }
            },
            introTour() {
                return [
                    {
                        target: '#btn-start-tour',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.kickstart.skiptour'
                        ),
                        params: {
                            enableScrolling: false,
                        },
                    },
                    {
                        target: '.v-bottom-navigation',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.kickstart.bottomnav'
                        ),
                    },
                    {
                        target: '#topbar-useravatar',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.kickstart.account'
                        ),
                    },
                    {
                        target: '#topbar-sidebartoggle',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.kickstart.menu'
                        ),
                    },
                    {
                        target: '.v-bottom-navigation a[value="shop"] .v-btn__content',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.kickstart.premiums'
                        ),
                    },
                ];
            },
            dashboardTour() {
                return [
                    {
                        target: '#dashboard-heronews',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.dashboard.news'
                        ),
                        params: {
                            placement: 'top',
                        },
                        offset: -500,
                    },
                    {
                        target: '#dashboard-wallet',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.dashboard.wallet_balance'
                        ),
                        params: {
                            placement: 'top',
                        },
                        offset: -500,
                    },
                    {
                        target: '#dashboard-contractclaim',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.dashboard.contract_claim'
                        ),
                        params: {
                            placement: 'top',
                        },
                        offset: -500,
                    },
                    {
                        target: '.rang-widget',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.dashboard.ranks'
                        ),
                        params: {
                            placement: 'top',
                        },
                        offset: -300,
                    },
                    {
                        target: '#ranks-detail-button',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.dashboard.rank_description'
                        ),
                        params: {
                            placement: 'top',
                        },
                        offset: -500,
                    },
                    {
                        target: '.v-bottom-navigation a[value="account"] .v-btn__content',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.dashboard.wallet'
                        ),
                        params: {},
                    },

                    // todo: add owner-specific step
                ];
            },
            shopTour() {
                return [
                    {
                        target: '#shop-filter-category',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.shop.filter'
                        ),
                        params: {
                            placement: 'bottom',
                        },
                        offset: -500,
                    },
                    {
                        target: '#shop-filter-points',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.shop.filter_points'
                        ),
                        params: {
                            enableScrolling: false,
                        },
                    },
                    {
                        target: '.wishlist-btn-icon',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.shop.wishlist'
                        ),
                        params: {
                            placement: 'bottom',
                        },
                        offset: -500,
                    },
                    {
                        target: '#topbar-sidebartoggle',
                        content: this.$vuetify.lang.t(
                            '$vuetify.guidedtour.shop.wishlist_position'
                        ),
                        params: {
                            placement: 'bottom',
                        },
                        offset: -500,
                    },
                ];
            },
        },
        watch: {
            tours(val) {
                this.$nextTick(() => {
                    if (val) {
                        const tour = this.availableTours.find(
                            (t) => t.route === this.$route.fullPath
                        );
                        if (tour && tour.id) {
                            this.currentTour = tour.id;
                        }
                    }
                });
            },
            $route(val) {
                if (this.tours) {
                    const tour = this.availableTours.find(
                        (t) => t.route === this.$route.fullPath
                    );
                    if (tour && tour.id) {
                        this.currentTour = tour.id;
                    }
                }
            },
        },
        methods: {
            ...mapActions([
                'set',
            ]),
            onStart(e) {
            },
            onPreviousStep(e) {
            },
            onNextStep(e) {
            },
            onSkip() {
                const tour = this.availableTours.find(
                    (t) => t.id === this.currentTour
                );
                this.set({
                    item: tour.store,
                    value: true,
                });
                this.currentTour = null;
            },
            onFinish() {
                const tour = this.availableTours.find(
                    (t) => t.id === this.currentTour
                );
                this.set({
                    item: tour.store,
                    value: true,
                });
                this.currentTour = null;
            },
        },
    };
</script>
